export type PrizmTheme = 'dark' | 'light' | string;
